import { render } from "./whatsapp.vue?vue&type=template&id=2bcc2b61"
import script from "./whatsapp.vue?vue&type=script&lang=js"
export * from "./whatsapp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__